module.exports = __webpack_public_path__ + "img/the-future-hr-icon.a0de841a.png";